import { render } from "./linkFail.vue?vue&type=template&id=60121833&scoped=true"
const script = {}

import "./linkFail.vue?vue&type=style&index=0&id=60121833&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60121833"]])

export default __exports__